import * as React from 'react';
import OlMap from 'ol/Map';
import OlControlZE from 'ol/control/ZoomToExtent';
import 'antd/dist/antd.min.css';
import ReactDOM from 'react-dom';
import { Extent } from 'ol/extent';
import { GlobalOutlined } from '@ant-design/icons';

interface IProps {
    map: OlMap;
    extent: Extent;
    tooltip?: string;
}

export class MyZoomToExtent extends React.Component<IProps, object> {
    constructor(props: IProps) {
        super(props);
        this._ref = React.createRef();
    }

    private _ref: React.LegacyRef<HTMLDivElement>;

    private myDiv: HTMLDivElement;

    createControl() {
        this.props.map.addControl(new OlControlZE({
            label: this.myDiv,
            tipLabel: this.props.tooltip,
            extent: this.props.extent
        }));
    }

    componentDidMount() {
        this.myDiv = document.createElement('div');
        this.createControl();
        ReactDOM.render(
            React.createElement(
                GlobalOutlined, {
                style: { fontSize: '15px' }
            }
            ),
            this.myDiv
        );
    }

    render() {
        return (
            <div ref={this._ref} />
        );
    }
}
export default MyZoomToExtent;
